
<script>
import { Doughnut, mixins } from 'vue-chartjs'
import ChartDataLabels from 'chartjs-plugin-labels';

Chart.plugins.unregister(ChartDataLabels);
const { reactiveProp } = mixins;

export default {
    extends: Doughnut,
    mixins: [reactiveProp],
    props: {
        chartData: {
            type: Object,
            required: true
        },
        options: {
            type: String,
        }
    },
    mounted () {
        this.addPlugin(ChartDataLabels);
        this.renderChart(this.chartData, JSON.parse(this.options))
    }
}
</script>
